import Immutable from 'immutable';

import Link from './Link';

export default Immutable.Record({
  name: undefined,
  link: new Link(),
});
